import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// 汎用チャート描画。<canvas data-controller="chart" data-chart-config-value="<%= {...}.to_json %>">
// に Chart.js の設定（{type, data, options}）を JSON で渡す。複合グラフ（積み上げbar+line+2軸）も
// dataset ごとの type / yAxisID 指定で表現できる。
//
// ドリルダウン（任意）:
//   data-chart-drill-url-value="/ca/candidates" data-chart-drill-param-value="status"
//   を付けると、棒/スライスのクリックで「<url>?<param>=<クリックしたラベル>」へ遷移する。
export default class extends Controller {
  static values = { config: Object, drillUrl: String, drillParam: String }

  connect() {
    this.chart = new Chart(this.element, this.buildConfig())
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  // 設定が動的に差し替わった場合に再描画する（Turbo更新など）。
  // ドリルダウンのハンドラも buildConfig 経由で必ず再適用する。
  configValueChanged() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = new Chart(this.element, this.buildConfig())
    }
  }

  // 共通オプション＋（指定時）ドリルダウンのハンドラを適用した Chart.js 設定を返す。
  buildConfig() {
    const config = { ...(this.configValue || {}) }
    config.options = {
      responsive: true,
      maintainAspectRatio: false,
      ...(config.options || {})
    }
    if (this.hasDrillUrlValue && this.drillUrlValue && this.hasDrillParamValue && this.drillParamValue) {
      config.options.onClick = (event, elements) => this.drillDown(elements)
      config.options.onHover = (event, elements) => {
        event.native.target.style.cursor = elements.length ? "pointer" : "default"
      }
    }
    return config
  }

  // クリックした要素のラベルを絞り込み値として一覧へ遷移する。
  drillDown(elements) {
    if (!elements || elements.length === 0) return
    const label = this.chart.data.labels[elements[0].index]
    if (label === undefined || label === null) return
    const url = new URL(this.drillUrlValue, window.location.origin)
    url.searchParams.set(this.drillParamValue, label)
    window.location.assign(url.toString())
  }
}
